import { useTranslation } from 'libs/i18n';
import { DocumentsSection } from 'modules/client/common/components/sections';

export const ClientDocumentsSection = () => {
  const { t } = useTranslation();
  return (
    <DocumentsSection
      title={t('client.client.documents.title')}
      titleVariant="subtitle"
    />
  );
};
